import { render } from "./CalChannelSlotEditor.vue?vue&type=template&id=3b8208bd&scoped=true"
import script from "./CalChannelSlotEditor.vue?vue&type=script&lang=js"
export * from "./CalChannelSlotEditor.vue?vue&type=script&lang=js"

import "@/assets/style.css?vue&type=style&index=0&lang=css"
import "./CalChannelSlotEditor.vue?vue&type=style&index=1&id=3b8208bd&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8208bd"]])

export default __exports__